import React from 'react'
import Header from './Header'
import Footer from './Footer'

const FrontLayout = ({children}) => {
  return (
    <>
        <Header/>
            {children}
        <Footer/>
    </>
  )
}

export default FrontLayout